import { DateTime } from "luxon";
import { SharedApiV2 } from "@capstone/mock-api";
import { Partner } from "src/app/partner/global/partner.model";
import { getApiDetailsDecorator, parseDateTime } from "src/utils";
import { getSiteRouteUrl } from "./site.model";

const api = getApiDetailsDecorator<SharedApiV2.SiteListDto>();
interface DeserializeArguments {
  partner: Partner;
}

export class SiteListItem {
  private constructor(args: ClassProperties<SiteListItem>) {
    this.createdDate = args.createdDate;
    this.customName = args.customName;
    this.defaultName = args.defaultName;
    this.id = args.id;
    this.modifiedDate = args.modifiedDate;
    this.partner = args.partner;
  }

  public readonly createdDate: DateTime | null;
  @api({ key: "displayName" }) public readonly customName: string | null;
  @api({ key: "name" }) public readonly defaultName: string;
  public readonly id: number;
  public readonly modifiedDate: DateTime | null;
  public readonly partner: Partner;

  private static deserialize(
    data: SharedApiV2.SiteListDto,
    { partner }: DeserializeArguments,
  ): SiteListItem {
    return new SiteListItem({
      createdDate: parseDateTime(data.createdDate),
      customName: data.displayName || null,
      defaultName: data.name,
      id: data.id,
      modifiedDate: parseDateTime(data.modifiedDate),
      partner,
    });
  }

  public static deserializeList(
    data: SharedApiV2.SiteListDtoPagedList,
    { partner }: DeserializeArguments,
  ): SiteListItem[] {
    return data.items.map((site) =>
      SiteListItem.deserialize(site, { partner }),
    );
  }

  public getRouteUrl(...childPaths: string[]): string {
    return getSiteRouteUrl(this, ...childPaths);
  }
}
